export class GraphqlClient {
  private shop: string;
  private adminAccessToken?: string;
  private storefrontAccessToken: string;
  private link = ``;

  constructor({
    shop,
    adminAccessToken,
    storefrontAccessToken,
  }: {
    shop: string;
    adminAccessToken?: string;
    storefrontAccessToken?: string;
  }) {
    this.shop = shop;
    if (storefrontAccessToken) {
      this.storefrontAccessToken = storefrontAccessToken;
      this.link = `https://${this.shop}/api/2024-10/graphql.json`;
    } else {
      this.adminAccessToken = adminAccessToken;
      this.link = `https://${this.shop}/admin/api/2024-10/graphql.json`;
    }
  }

  async request<
    T = unknown,
    TVariables extends Record<string, unknown> = Record<string, unknown>,
  >(query: string, variables?: TVariables): Promise<T> {
    const response = await fetch(this.link, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.storefrontAccessToken,
        "X-Shopify-Access-Token": this.adminAccessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      throw new Error(`GraphQL request failed with status: ${response.status}`);
    }

    const result = await response.json();
    if (result.errors) {
      throw new Error(`GraphQL errors: ${JSON.stringify(result.errors)}`);
    }

    return result.data as T;
  }
}
